import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=2313a7c4&scoped=true&"
import script from "./Kanban.vue?vue&type=script&lang=js&"
export * from "./Kanban.vue?vue&type=script&lang=js&"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=2313a7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313a7c4",
  null
  
)

export default component.exports